import React from 'react';

const HeaderRow = () => (
    <tr>
        <th />
        <th className="cp-favourites__specialCell hidden-sm-up" colSpan="2">
            non handicap
        </th>
        <th className="cp-favourites__specialCell hidden-sm-up" colSpan="2">
            handicap
        </th>
        <th className="cp-favourites__specialCell hidden-xs-down" colSpan="4">
            non handicap
        </th>
        <th className="cp-favourites__specialCell hidden-xs-down" colSpan="4">
            handicap
        </th>
    </tr>
);

export default HeaderRow;



// WEBPACK FOOTER //
// ./src/js/course/favourites/HeaderRow.jsx